import React from "react";
import "./Features.css";

const Features = () => {
  return (
    <div className="" style={{ overflow: "hidden" }}>
      <br/>
      <h1 className="">Capture & Collect</h1>
      <div className="w-screen grid grid-cols-1 md:grid-cols-3 my-10">
        {/* style={{ padding: "70px", margin: "10px 30px 10px 30px" }}> */}

        <div className="div-2">
          <i style={{ color: "grey" }} class="fa-solid fa-pen"></i>
          <h3>Written Moments</h3>
          <p className="p1">
            Quickly capture your moments in writing with a simple and easy to
            use interface.
          </p>
        </div>

        <div className="div-2 ">
          <i style={{ color: "grey" }} class="fa-solid fa-user-tag"></i>
          <h3>People, Places & Tags</h3>
          <p className="p1">
            Add people, places and tags to moments so you can organise and
            explore your memories.
          </p>
        </div>

        <div className="div-2 ">
          <i style={{ color: "grey" }} class="fa-regular fa-calendar-days "></i>
          <h3>Events</h3>
          <p className="p1">
            Create events to easily group your memorable moments together -
            perfect for birthdays and weddings.
          </p>
        </div>

        <div className="div-2">
          <i style={{ color: "grey" }} class="fa-solid fa-images"></i>
          <h3>Photos</h3>
          <p className="p1">
            Bring your memories to life with photos and videos, automatically
            grouped by time and place.
          </p>
        </div>

        <div className="div-2">
          <i style={{ color: "grey" }} class="fa-solid fa-bell"></i>
          <h3>Reminders</h3>
          <p className="p1">
            Never forget to capture your memories with preset and custom
            reminders..
          </p>
        </div>

        <div className="div-2">
          <i style={{ color: "grey" }} class="fa-solid fa-square-rss"></i>
          <h3>Feeds</h3>
          <p className="p1">
            Automatically import your daily activities, photos and videos from
            your social media accounts.
          </p>
        </div>
      </div>

      <div
        style={{
          width: "80vw",
          margin: "100px 120px 50px 120px",
          "border-top": "1.5px solid gray",
        }}
      ></div>

      <h1>Remember & Reflect</h1>

      <div
        className="w-screen grid grid-cols-1 md:grid-cols-3"
        // style={{ padding: "70px", margin: "10px 30px 10px 30px" }}
      >
        <div className="div-2">
          <i style={{ color: "grey" }} class="fa-regular fa-newspaper"></i>
          <h3>Visual Summaries</h3>

          <p className="p1">
            Summaries provide quick overview of each and every day, month and
            year at a glance.
          </p>
        </div>

        <div className="div-2">
          <i style={{ color: "grey" }} class="fa-solid fa-bars-staggered"></i>
          <h3>Explorable Timelines</h3>
          <p className="p1">
            Travel back in time and explore your past with timelines for every
            person, place, event, tag and feed.
          </p>
        </div>

        <div className="div-2">
          <i
            style={{ color: "grey" }}
            class="fa-solid fa-magnifying-glass-plus"
          ></i>
          <h3>Simple Search</h3>
          <p className="p1">
            Search your entire history in a tap — each moment, every feed and
            all your people, places and tags.
          </p>
        </div>
      </div>

      <div
        style={{
          width: "80vw",
          margin: "100px 120px 50px 120px",
          "border-top": "1.5px solid gray",
        }}
      ></div>

      <h1>Essential Features</h1>

      <div
        className="w-screen grid md:grid-cols-3 grid-cols-1"
        // style={{ padding: "70px", margin: "10px 30px 10px 30px" }}
      >
        <div className="div-2">
          <i style={{ color: "grey" }} class="fa-solid fa-calendar-days"></i>
          <h3>Calender</h3>
          <p className="p1">
            Quickly navigate to any date in your journal with the pop-up
            calendar..
          </p>
        </div>

        <div className="div-2">
          <i style={{ color: "grey" }} class="fa-solid fa-book-skull"></i>
          <h3>Quick Actions</h3>
          <p className="p1">
            Use 3D Touch to add a moment or search from your homescreen.
          </p>
        </div>

        <div className="div-2">
          <i style={{ color: "grey" }} class="fa-solid fa-person"></i>
          <h3>personalise</h3>
          <p className="p1">
            Customise summaries, the behaviour and look of Momento.
          </p>
        </div>

        <div className="div-2">
          <i style={{ color: "grey" }} class="fa-regular fa-newspaper"></i>
          <h3>Summaries</h3>
          <p className="p1">
            ARecall entire memories at a glance with summaries.
          </p>
        </div>

        <div className="div-2">
          <i style={{ color: "grey" }} class="fa-solid fa-cloud-arrow-up"></i>
          <h3>Backup</h3>
          <p className="p1">
            All your memories can be backed up to iCloud or locally on your
            device..
          </p>
        </div>

        <div className="div-2">
          <i style={{ color: "grey" }} class="fa-solid fa-share"></i>
          <h3>Sharing</h3>
          <p className="p1">
            Share memories as beautiful images privately or socially.
          </p>
        </div>
      </div>
      <div
        style={{
          width: "80vw",
          margin: "100px 120px 50px 120px",
          "border-top": "1.5px solid gray",
        }}
      ></div>

      <h1>Momento Premium</h1>

      {/* <div id='span'><span>Get the complete Momento experience by upgrading to Momento Premium. Unlock every feature available in Momento, including all future features and exclusive Premium features.</span></div> */}

      <div
        className="w-screen grid grid-cols-1 md:grid-cols-3"
        // style={{ padding: "70px", margin: "10px 30px 10px 30px" }}
      >
        <div className="div-2">
          <i style={{ color: "grey" }} class="fa-solid fa-square-rss"></i>
          <h3>Unlimited Feeds</h3>
          <p className="p1">
            Get unlimited feed connections to add as many feeds as you wish.
          </p>
        </div>

        <div className="div-2">
          <i style={{ color: "grey" }} class="fa-solid fa-bell"></i>
          <h3>Multiple Photos</h3>
          <p className="p1">Add multiple photos and videos to each moment.</p>
        </div>

        <div className="div-2">
          <i style={{ color: "grey" }} class="fa-solid fa-cloud-arrow-down"></i>
          <h3>Export</h3>
          <p className="p1">
            Export your journal as plain text alongside a folder of media.
          </p>
        </div>

        <div className="div-2">
          <i style={{ color: "grey" }} class="fa-solid fa-lock"></i>
          <h3>Lock</h3>
          <p className="p1">
            Protect Momento with a 4-digit passcode and biometrics.
          </p>
        </div>

        <div className="div-2">
          <i style={{ color: "grey" }} class="fa-solid fa-font"></i>
          <h3>Formatting</h3>
          <p className="p1">
            Add emphasis to your writing with bold and italics.{" "}
          </p>
        </div>

        <div className="div-2">
          <i style={{ color: "grey" }} class="fa-solid fa-paint-roller"></i>
          <h3>Themes</h3>
          <p className="p1">
            Personalise Momento with a simple splash of colour.
          </p>
        </div>

        <div className="div-2">
          <i style={{ color: "grey" }} class="fa-solid fa-clock"></i>
          <h3>Hourly Feed Updates</h3>
          <p className="p1">
            Get your latest activities in Momento with hourly feed updates.
          </p>
        </div>

        <div className="div-2">
          <i style={{ color: "grey" }} class="fa-solid fa-bookmark"></i>
          <h3>Future Features</h3>
          <p className="p1">
            All future premium features unlocked automatically.
          </p>
        </div>

        <div className="div-2">
          <i style={{ color: "grey" }} class="fa-regular fa-heart"></i>
          <h3>Support Development</h3>
          <p className="p1">
            Contribute towards the ongoing development of Momento.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Features;
